export default __webpack_public_path__ + "static/media/Anuphan-Medium.307a7242.woff";